import cx from "classnames";

import { ReactComponent as Check } from "./img/check.svg";
import { ReactComponent as CheckCircle } from "./img/checkCircle.svg";
import styles from "./styles.module.scss";

/**
 *
 * @param {object} props
 * @param {string} props.className
 * @param {ReactNode} props.children
 * @returns
 */

const renderCheck = isCircle => {
  if (isCircle) return <CheckCircle className={styles.checkCircle} />;
  else return <Check className={styles.check} />;
};

const BulletItem = ({ children, className = "", isCircle = false }) => {
  return (
    <li className={cx(styles.bulletItem, className)}>
      {renderCheck(isCircle)}
      <div className={styles.text}>{children}</div>
    </li>
  );
};

export default BulletItem;
